import { Injectable } from '@angular/core';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})

export class GisToolsApi {

    constructor(private readonly api: Api) { }

    districtProperties = 'id, districtNumber, name';
    countyProperties = 'id, countyCode, districtNumber, name';
    municipalityProperties = 'id, name, municipalityCode, countyCode';
    legislativeDistrictProperties = 'id, firstName, lastName, party, counties{id, name}, districts{id}, legislativeDistrictNumber, url, planningPartners{planningPartnerShortName}';

    async getDistricts(id: number[]) {
        return await this.api.http2.graphqlRequest(`query GetDistricts($id: [Int]) {
                districts(id: $id){
                    ${this.districtProperties}
                }
            }`, { id }, 'GET', 'districts');
    }

    async getCounties(id: number[]) {
        return await this.api.http2.graphqlRequest(`query GetCounties($id: [Int]) {
                counties(id: $id){
                    ${this.countyProperties}
                }
            }`, { id }, 'GET', 'counties');
    }

    async getCountiesByDistricts(districtNumbers: string[]) {
        return await this.api.http2.graphqlRequest(`query GetCounties($districtNumbers: [String]) {
                counties(districtNumber: $districtNumbers){
                    ${this.countyProperties}
                }
            }`, { districtNumbers }, 'GET', 'counties');
    }

    async getMunicipalitiesByCounty(countyCodes: string[]) {
        return await this.api.http2.graphqlRequest(`query GetMunicipalities($countyCodes: [String]) {
            municipalities(countyCode: $countyCodes){
                ${this.municipalityProperties}
            }
        }`, { countyCodes }, 'GET', 'municipalities');
    }

    async getCongressionalDistricts(id: number[]) {
        return await this.api.http2.graphqlRequest(`query GetCongressDistricts($id: [Int]) {
            uscongressionaldistricts(id: $id){
                ${this.legislativeDistrictProperties}
            }
        }`, { id }, 'GET', 'uscongressionaldistricts');
    }

    async getSenateDistricts(id: number[]) {
        return await this.api.http2.graphqlRequest(`query GetSenateDistricts($id: [Int]) {
            pasenatedistricts(id: $id){
                ${this.legislativeDistrictProperties}
            }
        }`, { id }, 'GET', 'pasenatedistricts');
    }

    async getHouseDistricts(id: number[]) {
        return await this.api.http2.graphqlRequest(`query GetHouseDistricts($id: [Int]) {
            pahousedistricts(id: $id){
                ${this.legislativeDistrictProperties}
            }
        }`, { id }, 'GET', 'pahousedistricts');
    }

    async getLayerIdByName(name: string[]) {
        return await this.api.http2.graphqlRequest(`query GetLayerIdByName($name: [String]) {
            layers(name: $name, typeId: 1) {
                id
            }
        }`, { name }, 'GET', 'layers');
    }
}
